// extracted by mini-css-extract-plugin
export default {"card":"yyoq3H9LioW9wn_k0iJU","body":"A_D3lzsVw6cLnR902c1Z","fadeIn":"M3cltRc8oFwbNRLik4xn"};